import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [footerRoot, setFooterRoot] = useState(null);

  useEffect(() => {
    // Create footer container outside of React root
    const footerContainer = document.createElement('div');
    footerContainer.id = 'footer-portal-root';
    document.body.appendChild(footerContainer);
    setFooterRoot(footerContainer);

    return () => {
      if (footerContainer && document.body.contains(footerContainer)) {
        document.body.removeChild(footerContainer);
      }
    };
  }, []);

  if (!footerRoot) return null;

  return ReactDOM.createPortal(
    <>
      <div className="he-footer-landing"></div>
      <div className="he-footer-container">
        <div className="he-footer-width">
          <div className="he-footer">
            <div className="he-footer-left">
              <img src="/images/helios-logo.png" alt="Helios Logo" className="he-footer-logo" />
            </div>
            <div className="he-footer-right">
              <span>© {currentYear} Helios Exchange, Inc.</span>
            </div>
          </div>
        </div>
      </div>
      <span id="word-width" style={{ display: 'none' }}></span>
    </>,
    footerRoot
  );
};

export default Footer;